import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ url, children }) => {
  const [socket, setSocket] = useState(null);
  const [socketStatus, setSocketStatus] = useState(false);

  // Live market को event ID के हिसाब से store करेगा
  const [liveMarkets, setLiveMarkets] = useState({});

  const reconnectTimerRef = useRef(null);
  const reconnectAttemptsRef = useRef(0);

  useEffect(() => {
    let ws;
    let unmounted = false;

    const connectWebSocket = () => {
      ws = new WebSocket(url);

      ws.onopen = () => {
        if (unmounted) return;

        console.log("✅ WebSocket connected:", url);

        reconnectAttemptsRef.current = 0;
        setSocket(ws);
        setSocketStatus(true);

        if (reconnectTimerRef.current) {
          clearTimeout(reconnectTimerRef.current);
        }
      };

      ws.onmessage = (event) => {
  try {
    const message = JSON.parse(event.data);

    console.log(
      "HOME SOCKET RECEIVED:",
      message
    );

    if (
      message?.action === "MARKET_UPDATE" &&
      message?.data
    ) {
      const eventId = String(
        message.data.event_id ??
        message.data.eventId
      );

      console.log(
        "SAVING LIVE MARKET:",
        eventId,
        message.data.market_types
      );

      setLiveMarkets((currentMarkets) => ({
        ...currentMarkets,
        [eventId]: message.data,
      }));
    }
  } catch (error) {
    console.error(
      "Socket parse error:",
      error
    );
  }
};

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
      };

      ws.onclose = () => {
        if (unmounted) return;

        console.warn("WebSocket disconnected");

        setSocket(null);
        setSocketStatus(false);

        reconnectAttemptsRef.current += 1;

        const reconnectDelay = Math.min(
          5000,
          1000 * reconnectAttemptsRef.current
        );

        reconnectTimerRef.current = setTimeout(
          connectWebSocket,
          reconnectDelay
        );
      };
    };

    connectWebSocket();

    return () => {
      unmounted = true;

      if (reconnectTimerRef.current) {
        clearTimeout(reconnectTimerRef.current);
      }

      if (ws) {
        ws.onclose = null;
        ws.close();
      }
    };
  }, [url]);

  const sendMessage = useCallback(
    (message) => {
      if (
        socket &&
        socket.readyState === WebSocket.OPEN
      ) {
        socket.send(JSON.stringify(message));
        return true;
      }

      console.error(
        "WebSocket not ready:",
        message
      );

      return false;
    },
    [socket]
  );

  return (
    <WebSocketContext.Provider
      value={{
        socket,
        socketStatus,
        sendMessage,
        liveMarkets,
      }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);

  if (!context) {
    throw new Error(
      "useWebSocket must be used inside WebSocketProvider"
    );
  }

  return context;
};